import React from 'react';
import { IconFlag, IconFlagFilled, IconSearch, IconSort } from 'components/Icons';

import './TransactionsTableTableSearch.scss';
import { prefixClass } from 'lib/utils';
import { useTransactionsTableContext } from '../../Chart/context/TransactionsTableContext';
import classNames from 'classnames';
import { Tooltip, Whisper } from 'rsuite';
import { getFlaggingTooltipMessage } from '../utils';

interface TransactionsTableTableSearchProps {
  onFlagTransaction?: () => void;
  flaggedCell?: any | undefined;
}

const TransactionsTableTableSearch: React.FC<TransactionsTableTableSearchProps> = ({
  flaggedCell,
  onFlagTransaction,
}) => {
  const ApiStatusToUIStatusMap = {
    Open: 'open',
    'In Progress': 'inProgress',
    Closed: 'closed',
  };

  const { search, setSearch, allowFlagging, isConsolidated } = useTransactionsTableContext();
  const isFlaggingDisabled = !allowFlagging;
  const flaggedStatus = flaggedCell
    ? ApiStatusToUIStatusMap[flaggedCell.status as keyof typeof ApiStatusToUIStatusMap]
    : undefined;
  const prefix = prefixClass('transactions-table-search');

  return (
    <div className={prefix()}>
      <div className={`${prefix('input-container')}`}>
        <div className={`${prefix('input-icon')}`}>
          <IconSearch />
        </div>
        <input
          type="text"
          name="search"
          placeholder="Search Transactions"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      {onFlagTransaction &&
        (isFlaggingDisabled ? (
          <Whisper
            placement="top"
            speaker={<Tooltip>{getFlaggingTooltipMessage(allowFlagging, isConsolidated)}</Tooltip>}
          >
            <button
              onClick={undefined}
              className={classNames(prefix('flag-button'), {
                [flaggedStatus as keyof typeof ApiStatusToUIStatusMap]: flaggedStatus,
                disabled: isFlaggingDisabled,
              })}
              data-testid="flag-button"
              disabled={isFlaggingDisabled}
            >
              {flaggedCell ? <IconFlagFilled /> : <IconFlag />}
            </button>
          </Whisper>
        ) : (
          <button
            onClick={onFlagTransaction}
            className={classNames(prefix('flag-button'), {
              [flaggedStatus as keyof typeof ApiStatusToUIStatusMap]: flaggedStatus,
            })}
            data-testid="flag-button"
          >
            {flaggedCell ? <IconFlagFilled /> : <IconFlag />}
          </button>
        ))}
    </div>
  );
};

export default TransactionsTableTableSearch;
